class AsistenciaService {
  constructor() {}
  resources = () => ({
    asistencia: {
      uri: `/v1/unidadcampamento/rptasistenciacampamento`,
      method: ['get']
    }
  });
}

export default AsistenciaService;
